import { ThemeConfig, theme } from 'antd';

const sharedTokens = {
  borderRadius: 6,
  fontSize: 14,
  lineHeight: 22 / 14,
  controlHeight: 32,
  fontFamily:
    "'SF Pro Text', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
};

export const antdLightTheme: ThemeConfig = {
  token: {
    ...sharedTokens,
    colorPrimary: '#24252C',
    colorPrimaryHover: '#6A6D81',
    colorPrimaryActive: '#3C3D49',
    colorPrimaryBg: '#E9E9ED',
    colorPrimaryBgHover: '#DBDBE1',
    colorPrimaryBorder: '#BEBECA',
    colorPrimaryBorderHover: '#8F91A3',
    colorPrimaryText: '#24252C',
    colorPrimaryTextHover: '#535565',
    colorPrimaryTextActive: '#3C3D49',
    colorInfo: '#24252C',
    colorInfoBg: '#E9E9ED',
    colorInfoBorder: '#BEBECA',
    colorInfoHover: '#6A6D81',
    colorInfoActive: '#3C3D49',
    colorInfoText: '#24252C',
    colorInfoTextHover: '#535565',
    colorBgSpotlight: '#ffffff',
    colorTextLightSolid: '#ffffff',
    colorLink: '#1677ff',
    colorLinkHover: '#4096ff',
    colorLinkActive: '#0958d9',
  },
  components: {
    Tooltip: {
      colorBgSpotlight: 'rgba(0, 0, 0, 0.85)',
      colorTextLightSolid: '#fff',
    },
    Button: {
      colorPrimary: '#24252C',
      colorPrimaryHover: '#6A6D81',
      colorPrimaryActive: '#3C3D49',
      primaryShadow: 'none',
      borderRadius: 8,
      defaultBorderColor: '#d9d9d9',
      defaultShadow: '0px 2px 0px 0px rgba(0,0,0,0.02)',
      paddingContentHorizontal: 15,
      colorLink: '#3B99F6',
      colorLinkHover: '#2775CF',
      colorLinkActive: '#1856A8',
    },
    Checkbox: {
      colorPrimary: '#24252C',
      colorPrimaryHover: '#6A6D81',
      colorPrimaryBorder: '#BEBECA',
      borderRadiusSM: 4,
    },
    DatePicker: {
      colorPrimary: '#24252C',
      colorPrimaryHover: '#6A6D81',
      colorPrimaryActive: '#3C3D49',
      borderRadius: 6,
      colorTextPlaceholder: '#A8AAB8',
      colorBorder: '#d9d9d9',
      colorText: 'rgba(0, 0, 0, 0.88)',
      colorTextSecondary: 'rgba(0, 0, 0, 0.88)',
      colorLink: '#24252C',
      colorLinkHover: '#535565',
      colorBgContainer: '#ffffff',
      controlItemBgActive: '#E9E9ED',
      controlItemBgHover: '#F1F1F4',
    },
    Modal: {
      borderRadiusLG: 8,
      boxShadow:
        '0px 6px 16px 0px rgba(0,0,0,0.08),0px 3px 6px -4px rgba(0,0,0,0.12),0px 9px 28px 8px rgba(0,0,0,0.05)',
    },
    Select: {
      optionActiveBg: '#E9E9ED',
      optionSelectedBg: '#E9E9ED',
      optionSelectedFontWeight: 600,
      selectorBg: '#ffffff',
      colorBorder: '#d9d9d9',
      colorText: 'rgba(0, 0, 0, 0.88)',
      colorTextPlaceholder: '#A8AAB8',
      borderRadius: 4,
      controlHeight: 30,
      fontSize: 14,
      colorPrimaryHover: '#6A6D81',
      colorPrimaryBorderHover: '#8F91A3',
      colorPrimaryBorder: '#BEBECA',
    },
    Tabs: {
      horizontalItemPadding: '8px 0',
      horizontalItemPaddingSM: '6px 0',
    },
    Menu: {
      itemBg: 'transparent',
      subMenuItemBg: 'transparent',
    },
  },
};

export const antdDarkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    ...sharedTokens,
    colorPrimary: '#F9F9FA',
    colorPrimaryHover: '#DBDBE1',
    colorPrimaryActive: '#F1F1F4',
    colorPrimaryBg: '#535565',
    colorPrimaryBgHover: '#6A6D81',
    colorPrimaryBorder: '#8F91A3',
    colorPrimaryBorderHover: '#BEBECA',
    colorPrimaryText: '#F9F9FA',
    colorPrimaryTextHover: '#E9E9ED',
    colorPrimaryTextActive: '#F1F1F4',
    colorInfo: '#F9F9FA',
    colorInfoBg: '#535565',
    colorInfoBorder: '#8F91A3',
    colorInfoHover: '#DBDBE1',
    colorInfoActive: '#F1F1F4',
    colorInfoText: '#F9F9FA',
    colorInfoTextHover: '#E9E9ED',
    colorBgContainer: '#3C3D49',
    colorBgElevated: '#3C3D49',
    colorBgLayout: '#24252C',
    colorBgSpotlight: '#3C3D49',
    colorBorder: '#535565',
    colorBorderSecondary: '#3C3D49',
    colorText: '#F9F9FA',
    colorTextSecondary: '#A8AAB8',
    colorTextTertiary: '#8F91A3',
    colorTextQuaternary: '#6A6D81',
    colorTextLightSolid: '#24252C',
    colorLink: '#4096ff',
    colorLinkHover: '#69b1ff',
    colorLinkActive: '#1677ff',
  },
  components: {
    Tooltip: {
      colorBgSpotlight: 'rgba(255, 255, 255, 0.95)',
      colorTextLightSolid: 'rgba(0, 0, 0, 0.88)',
    },
    Button: {
      colorPrimary: '#F9F9FA',
      colorPrimaryHover: '#DBDBE1',
      colorPrimaryActive: '#F1F1F4',
      primaryShadow: 'none',
      borderRadius: 8,
      defaultBorderColor: '#535565',
      defaultShadow: 'none',
      paddingContentHorizontal: 15,
      colorLink: '#5EA8E8',
      colorLinkHover: '#89C5F3',
      colorLinkActive: '#3585D4',
    },
    Checkbox: {
      colorPrimary: '#F9F9FA',
      colorPrimaryHover: '#DBDBE1',
      colorPrimaryBorder: '#8F91A3',
      colorBgContainer: '#3C3D49',
      colorBorder: '#535565',
      borderRadiusSM: 4,
    },
    DatePicker: {
      colorPrimary: '#F9F9FA',
      colorPrimaryHover: '#DBDBE1',
      colorPrimaryActive: '#F1F1F4',
      borderRadius: 6,
      colorTextPlaceholder: '#6A6D81',
      colorBorder: '#535565',
      colorText: '#F9F9FA',
      colorTextSecondary: '#A8AAB8',
      colorLink: '#F9F9FA',
      colorLinkHover: '#E9E9ED',
      colorBgContainer: '#24252C',
      colorBgElevated: '#3C3D49',
      activeBorderColor: '#BEBECA',
      hoverBorderColor: '#BEBECA',
      controlItemBgActive: '#535565',
      controlItemBgHover: '#6A6D81',
    },
    Modal: {
      borderRadiusLG: 8,
      boxShadow:
        '0px 6px 16px 0px rgba(0,0,0,0.2),0px 3px 6px -4px rgba(0,0,0,0.24),0px 9px 28px 8px rgba(0,0,0,0.15)',
    },
    Select: {
      optionActiveBg: '#535565',
      optionSelectedBg: '#535565',
      optionSelectedFontWeight: 600,
      selectorBg: '#24252C',
      colorBorder: '#535565',
      colorText: '#F9F9FA',
      colorTextPlaceholder: '#6A6D81',
      borderRadius: 4,
      controlHeight: 30,
      fontSize: 14,
      colorPrimaryHover: '#DBDBE1',
      colorPrimaryBorderHover: '#BEBECA',
      colorPrimaryBorder: '#8F91A3',
    },
    Tabs: {
      itemColor: '#A8AAB8',
      itemHoverColor: '#F9F9FA',
      itemSelectedColor: '#F9F9FA',
      inkBarColor: '#F9F9FA',
      horizontalItemPadding: '8px 0',
      horizontalItemPaddingSM: '6px 0',
    },
    Input: {
      colorBgContainer: '#24252C',
      colorText: '#F9F9FA',
      colorTextPlaceholder: '#6A6D81',
      colorBorder: '#535565',
      activeBorderColor: '#BEBECA',
      hoverBorderColor: '#BEBECA',
    },
    Menu: {
      itemBg: 'transparent',
      subMenuItemBg: 'transparent',
      itemColor: '#F9F9FA',
      itemHoverColor: '#F9F9FA',
      itemSelectedColor: '#F9F9FA',
      itemHoverBg: 'rgba(249, 249, 250, 0.08)',
      itemSelectedBg: 'rgba(249, 249, 250, 0.15)',
      groupTitleColor: '#A8AAB8',
    },
  },
};

/** @deprecated Use antdLightTheme or antdDarkTheme instead */
export const antdTheme = antdLightTheme;
